import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SharedService } from './shared.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let userToken = SharedService.showAdminApp ? localStorage.getItem("AdminToken") : localStorage.getItem("UserToken");
    req = req.clone({
      setHeaders: {
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json',
        'Authorization': `Bearer ${userToken}`,
      },
    });

    return next.handle(req);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/auth.interceptor.ts